import { Control } from "ol/control.js";
import Draw from "ol/interaction/Draw.js";
import {
  Circle as CircleStyle,
  Fill,
  RegularShape,
  Stroke,
  Style,
} from "ol/style.js";
import { Vector as VectorSource } from "ol/source.js";
import { Vector as VectorLayer } from "ol/layer.js";
import { Feature, getUid } from "ol";
import { Point } from "ol/geom";
import { capaActiva } from "../capaActiva";

class Punto extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const button = document.createElement("button");
    const tipLabel =
      options.tipLabel !== undefined ? options.tipLabel : "Dibujo Punto";
    button.title = tipLabel;
    button.innerText = "P";

    const element = document.createElement("div");
    element.className = "dibujo-control-punto ol-unselectable ol-control";
    element.appendChild(button);

    super({ element: element, target: options.target });
    this.vectorSource = options.source;
    this.vector = options.vector;

    this.draw = null;
    this.measureTooltipElement = null;
    this.helpTooltipElement = null;
    this.active = false;
    //agregado para poder desactivar global
    this.onActivate = options.onActivate;
    //agregado
    this.onRebuildLayer = options.onRebuildLayer;

    button.addEventListener("click", this.toggleMeasurement.bind(this), false);
  }

  toggleMeasurement() {
    if (!this.active) {
      // agregado para poder desactivar global
      if (this.onActivate) this.onActivate(this);

      if (!this.vector.getVisible()) {
        console.log("v");

        if (this.onRebuildLayer) {
          const { newSource, newVector } = this.onRebuildLayer(); // ✔ llama afuera
          this.vectorSource = newSource; // actualiza adentro
          this.vector = newVector;
        }
      }

      this.addInteraction();
      this.active = true;
      this.element.classList.add("activo");
    } else {
      // this.getMap().removeLayer(this.vectorLayer);
      this.getMap().removeInteraction(this.draw);
      this.element.classList.remove("activo");

      // this.vectorSource.clear();

      // this.draw = null;
      // this.measureTooltipElement = null;
      // this.helpTooltipElement = null;

      // const measureElements = document.querySelectorAll(
      //   ".ol-tooltip.ol-tooltip-static"
      // );
      // console.log(measureElements);
      // measureElements.forEach((element) => {
      //   element.remove();
      // });
      this.active = false;
    }
  }
  addInteraction() {
    const value = "Point";
    if (value !== "None") {
      this.draw = new Draw({
        source: this.vectorSource,
        type: "Point",
        freehand: true,
      });

      this.getMap().addInteraction(this.draw);
    }
    //evento al estar activo, y hacer keydown escape sacar activo
    window.addEventListener("keydown", (e) => {
      if (e.code == "Escape") {
        console.log("escale");
        //this.getMap().removeLayer(this.vectorLayer);
        //this.getMap().removeInteraction(this.draw);
        //this.element.classList.remove("activo");

        //this.vectorSource.clear();
        //this.active = false;

        this.getMap().removeInteraction(this.draw);
        this.element.classList.remove("activo");
      }
    });
  }
  desactivar() {
    this.getMap().removeInteraction(this.draw);
    //prueba
    this.getMap().removeLayer(this.vector);
    this.element.classList.remove("activo");
    this.active = false;
  }
}

export default Punto;
